import React from 'react';
import styled from 'styled-components';
import { themes } from 'kb-shared';
import { Title, ContainerPadding } from '../styled';

const Container = styled(ContainerPadding)`
  padding-top: 40px;
`;

const Text = styled.div`
  ${themes.fonts.FoundersGrotesk};
  font-size: 16px;
  font-weight: 300;
  color: white;
  padding-bottom: 28px;
`;

const ExplainerContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${themes.colors.KBTwilightDark};
  margin-bottom: 39px;

  @media screen and (min-width: ${themes.breakpoints.tabletPortrait}) {
    flex-direction: row;
  }
`;

const Explainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 20px;

  :first-of-type {
    border-bottom: 2px solid ${themes.colors.KBNight};
  }

  @media screen and (min-width: ${themes.breakpoints.tabletPortrait}) {
    :first-of-type {
      border-bottom: 0px solid ${themes.colors.KBNight};
      border-right: 2px solid ${themes.colors.KBNight};
    }
  }
`;

const SectionTitleText = styled.div`
  ${themes.fonts.FoundersGrotesk};
  font-weight: bold;
  color: ${themes.colors.KBYellow};
  line-height: 1.43;
`;

const SectionText = styled.div`
  ${themes.fonts.FoundersGrotesk}
  font-size: 14px;
  font-weight: 300;
  line-height: 1.43;
  color: white;
`;

const Interperatation = () => {
  return (
    <Container>
      <Title>Interpreting These Results</Title>
      <Text>
        During stimulation, we are monitoring a number of factors to get you ready for a successful
        egg retrieval, including follicle size and number, estrogen levels, and days of stimulation.
        Everyone's response is different and can vary from month to month. It typically takes about
        8-12 days of injections to get your ovaries ready.
      </Text>
      <ExplainerContainer>
        <Explainer>
          <SectionTitleText>When medication dosage might need to be adjusted</SectionTitleText>
          <SectionText>
            We may need to increase the dose of medications if too few follicles are developing and
            decrease the dose if too many are growing. We monitor you closely so that you do not get
            overstimulated, which can result in more undesirable side effects like bloating and
            abdominal discomfort.
          </SectionText>
        </Explainer>
        <Explainer>
          <SectionTitleText>Follicle growth & estrogen levels</SectionTitleText>
          <SectionText>
            When follicles are less than 10mm, it is hard to predict if they will continue to grow.
            When follicles grow over 10 mm, they will often continue to increase in size, most
            commonly 1-2mm every few days. Follicles over 13mm are most often going to contain
            mature eggs, though we don’t always get an egg from every follicle at the retrieval. We
            can only freeze or fertilize mature eggs. You are usually ready for the final trigger
            shot when the biggest follicles get to 17-22 mm. We want to maximize the number of good
            quality eggs for you, so the decision to trigger is based upon the entire cohort of
            follicles, not just the sizes of the few largest follicles.
          </SectionText>
        </Explainer>
      </ExplainerContainer>
    </Container>
  );
};

export default Interperatation;
